import { Service, Testimonial, PortfolioItem, WhyChooseCard } from "@/lib";
import { IMAGES } from "@/assets/images";

export const services: Service[] = [
  {
    id: "s1",
    title: "AI Automation Systems",
    description: "Streamline operations with intelligent agents and automated workflows that handle repetitive tasks 24/7.",
    icon: "Cpu",
  },
  {
    id: "s2",
    title: "Professional Website Development",
    description: "High-performance, futuristic websites built with cutting-edge tech stacks for maximum conversion.",
    icon: "Globe",
  },
  {
    id: "s3",
    title: "Social Media Growth Strategy",
    description: "Data-driven organic and paid strategies to skyrocket your brand presence across all digital platforms.",
    icon: "TrendingUp",
  },
  {
    id: "s4",
    title: "Business Branding & Funnels",
    description: "Complete identity design and high-converting sales funnels that turn visitors into loyal customers.",
    icon: "Zap",
  },
];

export const whyChooseUs: WhyChooseCard[] = [
  {
    id: "w1",
    title: "Smart AI Automation",
    description: "We integrate the latest LLMs and automation tools to make your business smarter.",
    icon: "Brain",
  },
  {
    id: "w2",
    title: "Conversion-Focused Websites",
    description: "Our designs aren't just pretty; they are engineered to drive results and sales.",
    icon: "Target",
  },
  {
    id: "w3",
    title: "Fast Delivery",
    description: "Rapid prototyping and deployment without compromising on premium quality.",
    icon: "Rocket",
  },
  {
    id: "w4",
    title: "Global Quality Standards",
    description: "Silicon Valley level engineering and luxury brand aesthetics for every client.",
    icon: "ShieldCheck",
  },
];

export const portfolioItems: PortfolioItem[] = [
  {
    id: "p1",
    title: "Nexus AI Platform",
    category: "AI Automation",
    image: IMAGES.PORTFOLIO_1,
    link: "#",
  },
  {
    id: "p2",
    title: "Lumina Luxury Real Estate",
    category: "Web Development",
    image: IMAGES.PORTFOLIO_2,
    link: "#",
  },
  {
    id: "p3",
    title: "Quantum Fintech Solutions",
    category: "Branding",
    image: IMAGES.PORTFOLIO_3,
    link: "#",
  },
  {
    id: "p4",
    title: "Aether SaaS Dashboard",
    category: "AI Integration",
    image: IMAGES.PORTFOLIO_4,
    link: "#",
  },
  {
    id: "p5",
    title: "Stellar E-commerce",
    category: "Funnels",
    image: IMAGES.PORTFOLIO_5,
    link: "#",
  },
  {
    id: "p6",
    title: "Vortex Media Agency",
    category: "Growth Strategy",
    image: IMAGES.PORTFOLIO_6,
    link: "#",
  },
];

export const testimonials: Testimonial[] = [
  {
    id: "t1",
    name: "Alexander Wright",
    role: "CEO, TechFlow Solutions",
    content: "Xuvera transformed our manual processes into a self-sustaining AI machine. Our efficiency increased by 400% within the first month.",
    rating: 5,
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Alexander",
  },
  {
    id: "t2",
    name: "Elena Rodriguez",
    role: "Founder, Bloom Marketing",
    content: "The website they built for us is a masterpiece. It feels like a mix of luxury and high-tech innovation. Simply world-class.",
    rating: 5,
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Elena",
  },
  {
    id: "t3",
    name: "Marcus Chen",
    role: "Operations Director, Global Logistics",
    content: "Working with Xuvera was the best decision for our digital transformation. Their AI agents handle our customer support flawlessly.",
    rating: 5,
    avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Marcus",
  },
];